import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AuctionIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.833 17.5h10v1.667h-10V17.5zM4.371 6.725l2.358-2.356 11.784 11.785-2.357 2.357L4.37 6.725zM10.264.833l4.714 4.714-2.358 2.358-4.712-4.717L10.264.833zM3.188 7.904l4.714 4.714-2.357 2.357-4.714-4.714 2.357-2.357z"
            />
        </SvgIcon>
    );
};
